export const CREATE_SPIN_REWARD_REQUEST = "CREATE_SPIN_REWARD_REQUEST";
export const CREATE_SPIN_REWARD_SUCCESS = "CREATE_SPIN_REWARD_SUCCESS";
export const CREATE_SPIN_REWARD_FAIL = "CREATE_SPIN_REWARD_FAIL";
export const RESET_DELETE_SPIN_REWARD = "RESET_DELETE_SPIN_REWARD";
export const FETCH_SPIN_REWARDS_REQUEST = "FETCH_SPIN_REWARDS_REQUEST";
export const FETCH_SPIN_REWARDS_SUCCESS = "FETCH_SPIN_REWARDS_SUCCESS";
export const FETCH_SPIN_REWARDS_FAIL = "FETCH_SPIN_REWARDS_FAIL";
export const UPDATE_SPIN_REWARD_REQUEST = "UPDATE_SPIN_REWARD_REQUEST";
export const UPDATE_SPIN_REWARD_SUCCESS = "UPDATE_SPIN_REWARD_SUCCESS";
export const UPDATE_SPIN_REWARD_FAIL = "UPDATE_SPIN_REWARD_FAIL";
export const DELETE_SPIN_REWARD_REQUEST = "DELETE_SPIN_REWARD_REQUEST";
export const DELETE_SPIN_REWARD_SUCCESS = "DELETE_SPIN_REWARD_SUCCESS";
export const DELETE_SPIN_REWARD_FAIL = "DELETE_SPIN_REWARD_FAIL";
export const FETCH_SPIN_REWARD_REQUEST = "FETCH_SPIN_REWARD_REQUEST";
export const FETCH_SPIN_REWARD_SUCCESS = "FETCH_SPIN_REWARD_SUCCESS";
export const FETCH_SPIN_REWARD_FAIL = "FETCH_SPIN_REWARD_FAIL";
